var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("KioskSplashLayout", { class: _vm.$rounds.optionsWrapper }, [
    _c(
      "div",
      { class: _vm.$rounds.optionsButtons },
      [
        _c(
          "BaseButton",
          {
            class: [
              _vm.$rounds.kioskRoundButton,
              _vm.$rounds.kioskRoundButtonWithPaddings
            ],
            attrs: { "button-style": "Round" },
            on: { click: _vm.handleNewOrder }
          },
          [_c("span", [_vm._v("New Order")])]
        ),
        _vm._v(" "),
        _c(
          "BaseButton",
          {
            class: _vm.$rounds.kioskRoundButton,
            attrs: { "button-style": "Round" },
            on: { click: _vm.handlePastOrders }
          },
          [
            _c("span", { class: _vm.$style.newLabel }, [_vm._v("New")]),
            _vm._v(" "),
            _c("span", [_vm._v("Past Order Lookup")])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/kiosk/components/MainOrderOptions.vue?vue&type=template&id=bc024a50&
// module id = null
// module chunks = 